
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/hosted-link/embedded-clients",
      function () {
        return require("private-next-pages/docs/link/hosted-link/embedded-clients.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/hosted-link/embedded-clients"])
      });
    }
  